import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "projects-panel" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "item-meta"
}
const _hoisted_4 = {
  key: 2,
  class: "project-grid"
}
const _hoisted_5 = ["onClick", "onKeydown"]
const _hoisted_6 = { class: "project-main" }
const _hoisted_7 = { class: "project-left" }
const _hoisted_8 = { class: "project-title" }
const _hoisted_9 = { class: "item-meta" }
const _hoisted_10 = { class: "item-meta" }
const _hoisted_11 = { class: "item-meta" }
const _hoisted_12 = { class: "gauge-wrap" }
const _hoisted_13 = { class: "gauge-shell" }
const _hoisted_14 = {
  viewBox: "0 0 200 120",
  class: "gauge-svg",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "gauge-value" }
const _hoisted_16 = { class: "gauge-legend" }
const _hoisted_17 = { class: "project-right" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = {
  key: 1,
  class: "project-photo project-photo-empty"
}
const _hoisted_20 = {
  key: 1,
  class: "item-card"
}
const _hoisted_21 = { class: "item-title" }
const _hoisted_22 = { class: "item-meta" }
const _hoisted_23 = { class: "item-meta" }
const _hoisted_24 = { class: "item-meta" }
const _hoisted_25 = { class: "item-meta" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "actions" }
const _hoisted_28 = {
  key: 2,
  class: "form-grid"
}
const _hoisted_29 = {
  key: 0,
  class: "item-card"
}
const _hoisted_30 = { class: "item-title" }
const _hoisted_31 = { class: "item-meta" }
const _hoisted_32 = { class: "item-meta" }
const _hoisted_33 = { class: "item-meta" }
const _hoisted_34 = { class: "item-meta" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "input-field" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "input-field" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "input-field" }
const _hoisted_41 = {
  key: 0,
  class: "grid",
  style: {"gap":"10px"}
}
const _hoisted_42 = ["value", "onChange"]
const _hoisted_43 = ["value"]
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = {
  key: 1,
  class: "item-meta"
}
const _hoisted_46 = { class: "input-field" }
const _hoisted_47 = {
  class: "grid",
  style: {"gap":"10px"}
}
const _hoisted_48 = ["value", "onChange"]
const _hoisted_49 = ["value"]
const _hoisted_50 = ["value", "onInput"]
const _hoisted_51 = ["value", "onInput"]
const _hoisted_52 = ["value", "onInput"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "actions" }
const _hoisted_56 = {
  key: 1,
  class: "subtitle error-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonList = _resolveComponent("SkeletonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.projectMode === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showSkeleton)
            ? (_openBlock(), _createBlock(_component_SkeletonList, {
                key: 0,
                variant: "card",
                count: 3
              }))
            : (_ctx.projects.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Nenhum projeto disponivel."))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (proj) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: proj.id,
                      class: "project-card clickable-card",
                      role: "button",
                      tabindex: "0",
                      onClick: ($event: any) => (_ctx.$emit('extend-project', proj.id)),
                      onKeydown: [
                        _withKeys(_withModifiers(($event: any) => (_ctx.$emit('extend-project', proj.id)), ["prevent"]), ["enter"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.$emit('extend-project', proj.id)), ["prevent"]), ["space"])
                      ]
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h3", _hoisted_8, _toDisplayString(proj.name), 1),
                          _createElementVNode("div", _hoisted_9, "Responsavel: " + _toDisplayString(_ctx.leadResponsible(proj)), 1),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[7] || (_cache[7] = _createTextVNode(" Status: ", -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.insightFor(proj.id).status === 'atrasado' ? 'status-late' : 'status-ok')
                            }, _toDisplayString(_ctx.insightFor(proj.id).status === 'atrasado' ? 'Atrasado' : 'Em dia'), 3)
                          ]),
                          _createElementVNode("div", _hoisted_11, "Previsao de conclusao: " + _toDisplayString(_ctx.forecastText(proj.id)), 1),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                                _cache[8] || (_cache[8] = _createElementVNode("path", {
                                  class: "gauge-track",
                                  d: "M20 100 A80 80 0 0 1 180 100",
                                  pathLength: "100"
                                }, null, -1)),
                                _createElementVNode("path", {
                                  class: "gauge-planned",
                                  d: "M20 100 A80 80 0 0 1 180 100",
                                  pathLength: "100",
                                  style: _normalizeStyle(_ctx.arcStyle(_ctx.insightFor(proj.id).plannedPercent))
                                }, null, 4),
                                _createElementVNode("path", {
                                  class: "gauge-actual",
                                  d: "M20 100 A80 80 0 0 1 180 100",
                                  pathLength: "100",
                                  style: _normalizeStyle(_ctx.arcStyle(_ctx.insightFor(proj.id).actualPercent))
                                }, null, 4)
                              ])),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.percentText(_ctx.insightFor(proj.id).actualPercent)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "dot dot-planned" }, null, -1)),
                                _createTextVNode("Planejado " + _toDisplayString(_ctx.percentText(_ctx.insightFor(proj.id).plannedPercent)), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "dot dot-actual" }, null, -1)),
                                _createTextVNode("Real " + _toDisplayString(_ctx.percentText(_ctx.insightFor(proj.id).actualPercent)), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (_ctx.hasPhoto(proj.photoDataUrl))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "project-photo",
                                src: _ctx.photoSrc(proj.photoDataUrl),
                                alt: proj.name
                              }, null, 8, _hoisted_18))
                            : (_openBlock(), _createElementBlock("div", _hoisted_19, "Sem foto"))
                        ])
                      ])
                    ], 40, _hoisted_5))
                  }), 128))
                ]))
        ]))
      : (_ctx.projectMode === 'view')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.selectedProject?.name), 1),
            _createElementVNode("div", _hoisted_22, "Acesso: " + _toDisplayString(_ctx.selectedProject?.accessMode === 'read' ? 'Somente leitura' : 'Edicao'), 1),
            _createElementVNode("div", _hoisted_23, "Responsaveis: " + _toDisplayString((_ctx.selectedProject?.responsibleNames || []).join(', ') || '-'), 1),
            _createElementVNode("div", _hoisted_24, "Temporarios: " + _toDisplayString(_ctx.selectedProject ? _ctx.tempResponsibleNames(_ctx.selectedProject) : '-'), 1),
            _createElementVNode("div", _hoisted_25, "Criado em: " + _toDisplayString(_ctx.selectedProject ? _ctx.formatReportDate(_ctx.selectedProject.createdAt.slice(0, 10)) : '-'), 1),
            (_ctx.hasPhoto(_ctx.selectedProject?.photoDataUrl || ''))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "project-photo-large",
                  src: _ctx.photoSrc(_ctx.selectedProject?.photoDataUrl || ''),
                  alt: _ctx.selectedProject?.name || 'Projeto'
                }, null, 8, _hoisted_26))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-project-mode')))
              }, "Fechar")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_ctx.selectedProject)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.selectedProject.name), 1),
                  _createElementVNode("div", _hoisted_31, "Acesso: " + _toDisplayString(_ctx.selectedProject.accessMode === 'read' ? 'Somente leitura' : 'Edicao'), 1),
                  _createElementVNode("div", _hoisted_32, "Responsaveis: " + _toDisplayString((_ctx.selectedProject.responsibleNames || []).join(', ') || '-'), 1),
                  _createElementVNode("div", _hoisted_33, "Temporarios: " + _toDisplayString(_ctx.tempResponsibleNames(_ctx.selectedProject)), 1),
                  _createElementVNode("div", _hoisted_34, "Criado em: " + _toDisplayString(_ctx.formatReportDate(_ctx.selectedProject.createdAt.slice(0, 10))), 1),
                  (_ctx.hasPhoto(_ctx.selectedProject.photoDataUrl))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "project-photo-large",
                        src: _ctx.photoSrc(_ctx.selectedProject.photoDataUrl),
                        alt: _ctx.selectedProject.name
                      }, null, 8, _hoisted_35))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "project-name" }, "Nome do projeto", -1)),
              _createElementVNode("input", {
                id: "project-name",
                value: _ctx.projectForm.name,
                type: "text",
                placeholder: "Nome do projeto",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-project-form', { field: 'name', value: ($event.target as HTMLInputElement).value })))
              }, null, 40, _hoisted_37)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "project-photo" }, "Foto do projeto (unica)", -1)),
              _createElementVNode("input", {
                id: "project-photo",
                type: "file",
                accept: "image/*",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onProjectPhotoSelected && _ctx.onProjectPhotoSelected(...args)))
              }, null, 32),
              (_ctx.projectForm.photoDataUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "project-photo-large",
                    src: _ctx.projectForm.photoDataUrl,
                    alt: "preview projeto"
                  }, null, 8, _hoisted_39))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _cache[14] || (_cache[14] = _createElementVNode("label", null, "Responsaveis", -1)),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectForm.responsibleUsernames, (username, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `main-resp-${index}`,
                        class: "list-row"
                      }, [
                        _createElementVNode("select", {
                          value: username,
                          onChange: ($event: any) => (_ctx.$emit('update-project-form', { field: 'responsibleUsernames', index, value: ($event.target as HTMLSelectElement).value }))
                        }, [
                          _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: acc.username,
                              value: acc.username
                            }, _toDisplayString(acc.name) + " (" + _toDisplayString(acc.username) + ") ", 9, _hoisted_43))
                          }), 128))
                        ], 40, _hoisted_42),
                        _createElementVNode("button", {
                          class: "btn btn-accent",
                          type: "button",
                          disabled: _ctx.projectForm.responsibleUsernames.length <= 1,
                          onClick: ($event: any) => (_ctx.$emit('remove-responsible', index))
                        }, "Excluir", 8, _hoisted_44)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      class: "btn btn-ghost",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('add-responsible')))
                    }, "+")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString((_ctx.selectedProject?.responsibleNames || []).join(', ') || '-'), 1))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _cache[16] || (_cache[16] = _createElementVNode("label", null, "Acrescentar responsaveis temporarios", -1)),
              _createElementVNode("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectForm.tempResponsibles, (temp, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `temp-${index}`,
                    class: "temp-row"
                  }, [
                    _createElementVNode("select", {
                      value: temp.username,
                      onChange: ($event: any) => (_ctx.emitTemp(index, 'username', ($event.target as HTMLSelectElement).value))
                    }, [
                      _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subordinateOptions, (acc) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: acc.username,
                          value: acc.username
                        }, _toDisplayString(acc.name) + " (" + _toDisplayString(acc.username) + ") ", 9, _hoisted_49))
                      }), 128))
                    ], 40, _hoisted_48),
                    (!temp.useSpecificDate)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "number",
                          min: "1",
                          value: temp.days,
                          placeholder: "Dias",
                          onInput: ($event: any) => (_ctx.emitTemp(index, 'days', ($event.target as HTMLInputElement).value))
                        }, null, 40, _hoisted_50))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("input", {
                            type: "date",
                            value: temp.startDate,
                            onInput: ($event: any) => (_ctx.emitTemp(index, 'startDate', ($event.target as HTMLInputElement).value))
                          }, null, 40, _hoisted_51),
                          _createElementVNode("input", {
                            type: "date",
                            value: temp.endDate,
                            onInput: ($event: any) => (_ctx.emitTemp(index, 'endDate', ($event.target as HTMLInputElement).value))
                          }, null, 40, _hoisted_52)
                        ], 64)),
                    _createElementVNode("button", {
                      class: "link link-inline",
                      type: "button",
                      onClick: ($event: any) => (_ctx.emitTemp(index, 'useSpecificDate', !temp.useSpecificDate))
                    }, _toDisplayString(temp.useSpecificDate ? 'Quantidade de dias' : 'Data especifica'), 9, _hoisted_53),
                    _createElementVNode("button", {
                      class: "btn btn-accent",
                      type: "button",
                      onClick: ($event: any) => (_ctx.$emit('remove-temp-responsible', index))
                    }, "Excluir", 8, _hoisted_54)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('add-temp-responsible')))
                }, "+")
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('save-project')))
              }, "Salvar"),
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close-project-mode')))
              }, "Cancelar")
            ]),
            (_ctx.projectError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_ctx.projectError), 1))
              : _createCommentVNode("", true)
          ]))
  ]))
}